import { Home, Description, Circle, Equalizer, ShoppingCart, Person, InsertDriveFile } from '@mui/icons-material';
import Settings from './app/views/admin/settings';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import Blogs from './app/views/admin/Blog/Blogs';
import PostAddIcon from '@mui/icons-material/PostAdd';
const Navigation = [
  {
    name: "Dashboard",
    icon: <Home />,
    path:"/dashboard"
    // subMenu: [
    //   {
    //     name: "Default",
    //     path: "/default",
    //     icon: <Circle />
    //   },
    //   {
    //     name: "CRM",
    //     path: "/crm",
    //     icon: <Circle />
    //   },
    // ]
  },
  {
    name: "Hardcoded",
    text: "Pages",
  },
  // {
  //   name: "Pages",
  //   icon: <InsertDriveFile />,
  //   subMenu: [
  //     {
  //       name: "Profile",
  //       icon: <Circle />,
  //       path: "/profile"
  //     },
  //     {
  //       name: "Users",
  //       icon: <Circle />,
  //       path: "/users"
  //     },
  //     {
  //       name: "Account",
  //       icon: <Circle />,
  //       path: "/account"
  //     },
  //   ]
  // },
   {
    name: "Vendors",
    icon: <Person />,
    path:"/vendors",    
  },
  {
    name: "Users",
    icon: <Person />,
    path:"/userslist",    
  },
    {
    name: "Blogs",
    icon: <PostAddIcon />,
    path:"/blogs",    
  },
  {
    name: "Orders",
    icon: <ShoppingCart />,
    path:"/orderslist",    
  },
  // {
  //   name: "Vouchers",
  //   icon: <ConfirmationNumberIcon />,
  //   path:"/voucher-list",    
     
  // },
  {
    name: "Collections",
    icon: <ShoppingCart />,
    subMenu: [
      {
        name: "Categories",
        icon: <Circle />,
        path:"/collections-category-list",    
      },
      {
        name: "Collections",
        icon: <Circle />,
        path:"/collection-list",    
      },
    ]    
  },
 
  {
    name: "Settings",
    icon: <ShoppingCart />,
    subMenu: [
      {
        name: "Costings",
        icon: <Circle />,
        path:"/costing",    
      },
      {
        name: "Colors",
        icon: <Circle />,
        path:"/colors",    
      },
    ]    
  },

  
];

export default Navigation;